import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ChamberCard } from "./ChamberCard";

export function useMidtermsHub() {
  const [hub, setHub] = useState(null);
  useEffect(() => {
    let alive = true;
    const load = () => api.get("/midterms/hub").then((r) => alive && setHub(r.data)).catch(() => {});
    load();
    const t = setInterval(load, 30000);
    return () => { alive = false; clearInterval(t); };
  }, []);
  return hub;
}

export function Chambers({ hub }) {
  const s = hub.senate;
  const h = hub.house;
  const g = hub.governors;
  const sTotal = 100;
  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 lg:gap-6">
      <ChamberCard
        title="Senate" kicker={`${s.total_up} seats up`} testid="midterms-chamber-senate"
        d={s.running_total.D} r={s.running_total.R} o={s.running_total.I}
        ld={s.leading.D} lr={s.leading.R} total={sTotal} needed={s.needed_for_control}
        footnote={`${s.needed_for_control} for control · ${s.uncalled} uncalled`}
      />
      <ChamberCard
        title="House" kicker="435 seats" testid="midterms-chamber-house"
        d={h.called.D} r={h.called.R} o={h.called.O}
        ld={h.leading.D} lr={h.leading.R} total={h.total_seats} needed={h.needed_for_control}
        footnote={`${h.needed_for_control} for control · ${h.uncalled} uncalled`}
      />
      <ChamberCard
        title="Governors" kicker={`${g.total_up} races`} testid="midterms-chamber-governors"
        d={g.running_total.D} r={g.running_total.R} o={g.running_total.I}
        ld={g.leading.D} lr={g.leading.R} total={50} needed={g.needed_for_control}
        footnote={`50 governorships · ${g.uncalled} uncalled`}
      />
    </div>
  );
}

export function FeedStatus({ feed }) {
  if (!feed) return null;
  const live = feed.live || feed.counting;
  return (
    <div className="flex items-center gap-2 text-[10px] uppercase tracking-[0.2em] text-white/60" data-testid="midterms-feed-status">
      <span className={`w-2 h-2 rounded-full ${live ? "bg-[#E81B23] midterms-pulse" : "bg-white/40"}`} />
      {live
        ? `Live · updated ${feed.as_of ? new Date(feed.as_of).toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" }) : "now"}`
        : "Polls open Tuesday, Nov 3 · results auto-update"}
    </div>
  );
}
